var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-user.691564be.png","uri@2x": __webpack_public_path__ + "icon-user.9591e0c6.png","uri@3x": __webpack_public_path__ + "icon-user.26cc8798.png",
    width: 30,
    height: 32
});